import { selectCurrUser } from '@/store/bootstrap/selectors';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useSafeSelector } from './use-safe-selector';

// Developers can override flags here and test them in development
const devOverrideFlags = {
  feReq: true,
  feAiSearch: false,
  feJobProfile: true,
  feNewPdfViewer: true,
  fePublicApiApplication: true,
  feOverrideType: true,
  feTransferCandidateSc: true,
  tNLevelTransfer: true,
  feScorecardVisibility: true,
  feScorecardThreshold: true,
  feNewVideoPlayer: true,
  // agents
  feJobTeammates: true,
  feCoordinatorAgent: false,
  feFraudDetection: true,
  feFraudMax: true,
  feAiAutoRejectEmail: true,
  // candidate availability
  feCandidateAvailability: true,
  feAgentForce: false,
  feScorecardOptional: true,
  feRemoteInterview: true,
  feNotificationCenter: true,
  feInterviewBuffer: true,
  feManualInterviewBuffer: false,
  feScheduleAll: true,
  feScheduleAllV2: true,
  tUnifiedCreditManagement: true,
  tConsentManagement: true,
  feKanbanPragmaticDnd: true,
  feStageAutomation: true,
  feOfferTemplateMultiDocuments: true,
  feOfferTemplatePdfPreview: true,
  feDarwinbox: true,
  feSpotdraft: true,
  feOfferFieldReorder: true,
  flowsBulkActions: true,
  feJobListingChanges: true,
  tInterviewerPrepAgent: true,
  internalJobsPost: true,
  feDocusignOfferPreview: true,
  feSpringverify: true,
  tOfferSections: true,
  pInterviewerAssistant: false,
  tDemoInterviewHarness: false,
  feCandidateActivitiesRevamp: true,
};

export const useKFlags = () => {
  const flags = useFlags();

  // Wrap the selector in useSafeSelector to prevent errors for non redux app like assessment or signup and assign default value for currUser
  const currUser = useSafeSelector(selectCurrUser) || {
    feature_options: {
      ats_enabled: false,
      circles_enabled: false,
      outreach_enabled: false,
    },
  };

  return {
    ...flags,
    ...currUser?.feature_options,
    ...(import.meta.env.VITE_ENV === 'development' ? devOverrideFlags : {}),
  };
};
